import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DarkModeService } from '@changePage/app/core/services';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  protected readonly title = signal('web.cambiaaltok-client-ui');
  readonly darkModeService = inject(DarkModeService);
}
